import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=908ca058&scoped=true&"
import script from "./Questionnaire.vue?vue&type=script&lang=js&"
export * from "./Questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./Questionnaire.vue?vue&type=style&index=0&id=908ca058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908ca058",
  null
  
)

export default component.exports